module.exports = __webpack_public_path__ + "img/icon-addonetether-01.svg";